import { render } from "./SelfRegistration.vue?vue&type=template&id=25ef5fba&scoped=true"
import script from "./SelfRegistration.vue?vue&type=script&lang=js"
export * from "./SelfRegistration.vue?vue&type=script&lang=js"

import "./SelfRegistration.vue?vue&type=style&index=0&id=25ef5fba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ef5fba"]])

export default __exports__